export default "__VITE_ASSET__C49dJ_xK__"